<template>
  <div>
    <Filters
      :filters="locationsManagementFilters"
      filter-key="locationsManagement"
      :initial-data="filtersStatus.locationsManagement"
      :loading="filtersLoading"
    />

    <ViewActionButtons :buttons="actionButtons" />

    <TableWrapper
      :table-columns="locationsManagementColumns"
      table-key="locationsManagement"
      row-key="tableId"
      @editLocation="openEditModal"
      @disableLocation="disableLocation"
    />

    <CreateEditLocation
      v-if="openCreateEditLocation"
      :is-modal-edit="isModalEdit"
      :initial-data="initialLocationData"
      @dialogClose="handleDialogClose"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import {
    locationsManagementFilters,
    locationsManagementColumns,
  } from '@/config';
  import { locationsManagementApi } from '@/api';
  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import ViewActionButtons from '@/components/ViewActionButtons.vue';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import axios from 'axios';
  import CreateEditLocation from './CreateEditLocation.vue';

  export default {
    name: 'LocationsManagementIndex',
    components: {
      Filters,
      TableWrapper,
      ViewActionButtons,
      CreateEditLocation,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    data() {
      return {
        locationsManagementFilters,
        locationsManagementColumns,
        actionButtons: [
          {
            text: this.$t('locationsManagement.createLocation'),
            type: 'primary',
            permissions: ['locationsManage'],
            action: () => {
              this.openCreateEditLocation = true;
            },
          },
        ],
        openCreateEditLocation: false,
        isModalEdit: false,
        initialLocationData: {},
      };
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        try {
          const locationsManagementIndex = await locationsManagementApi.index(
            this.tableFilters('locationsManagement'),
            this.filtersStatus.locationsManagement,
            { signal }
          );
          const locationsManagementCount = await locationsManagementApi.count(
            this.filtersStatus.locationsManagement,
            { signal }
          );
          this.updateTableRows({
            tableKey: 'locationsManagement',
            rows: locationsManagementIndex.data,
          });
          this.updateTableCount({
            tableKey: 'locationsManagement',
            count: locationsManagementCount.data.count,
          });
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
      disableLocation(row) {
        this.$confirm(
          this.$t('global.confirmAction'),
          this.$t('global.warning'),
          {
            confirmButtonText: this.$t('global.confirm'),
            cancelButtonText: this.$t('global.cancel'),
          }
        ).then(async () => {
          const data = {
            enabled: false,
          };
          await locationsManagementApi.patch(row.id, data);
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('locationsManagement.create.success'),
          });
          this.tableRows();
        });
      },
      openEditModal(row) {
        this.initialLocationData = row;
        this.isModalEdit = true;
        this.openCreateEditLocation = true;
      },
      handleDialogClose(status) {
        this.openCreateEditLocation = false;
        if (this.isModalEdit) this.isModalEdit = false;
        if (status.success) this.tableRows();
      },
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
  };
</script>
